import React from "react";
// Data and Utils
import onlineAssessmentsData from "./data/pageContentData/onlineAssessmentsContent.data.json";
import onlineAssessmentsSeo from "./data/onlineAssessmentsSeo.data.json";
import onlineAssessmentsSchema from "./data/onlineAssessmentsSchema.data.json";
import { constructSchemaData } from "utils/helpers/constructSchemaData";
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";
// Components
import SEO from "components/CBSEO";
import SchemaComponent from "components/CBSchema";
import { StyledPageContainer } from "styles/components/PageContainer/index.styles";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import { ImageContainer } from "styles/components/imageContainer";
import TextBlock from "components/TextBlock";
import CBDivider from "components/CBDivider";
import GetStartedToday from "pages/TherapyHub/components/GetStartedToday";
import InsuranceSection from "components/InsuranceSection";
import StartYourJourney from "pages/TherapyHub/components/startYourJourney";
import FAQContent from "components/CBFAQ";
import DynamicHero from "components/DynamicHero";
import ResourcesSlider from "pages/TherapyHub/components/resourcesSlider";

const componentMap = {
  "TwoColumnSection": TwoColumnSection,
  "ImageContainer": ImageContainer,
  "TextBlock": TextBlock,
  "Divider": CBDivider,
  "GetStartedToday": GetStartedToday,
  "InsuranceSection": InsuranceSection,
  "StartYourJourney": StartYourJourney,
  "Faq": FAQContent,
  "DynamicHero": DynamicHero,
  "ResourcesSlider": ResourcesSlider,
};

const OnlineAssessmentHub = () => {
  const seoData = onlineAssessmentsSeo;
  const schemaDataRaw = onlineAssessmentsSchema;
  const schemaData = schemaDataRaw.url ? constructSchemaData(schemaDataRaw.url, schemaDataRaw.breadcrumbs) : [];

  const renderedComponents = useDynamicPageRenderer(onlineAssessmentsData, componentMap);

  return (
    <StyledPageContainer id="online-assessment-hub-page-container">
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      <SchemaComponent schemas={schemaData} />
      {renderedComponents}
    </StyledPageContainer>
  );
};

export default OnlineAssessmentHub;
